import { useState } from "react";
import { useNavigate } from "react-router";
import { queryClient } from "../api";
import { memoirsApiInstance } from "../api/api";
import {
  selectUser,
  selectUserToken,
  startImpersonation,
} from "../store/slices/auth";
import { useDispatch, useSelector } from "../store/store";
import { User } from "../types/models";

type ImpersonateResponse = {
  user: User;
  token: string;
};

export const useImpersonate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentUser = useSelector(selectUser);
  const currentToken = useSelector(selectUserToken);
  const [loading, setLoading] = useState(false);

  const impersonate = async (userId: number) => {
    if (!currentToken || !currentUser || userId === currentUser.id) return;
    setLoading(true);
    try {
      const res = await memoirsApiInstance.post<ImpersonateResponse>(
        `/admin/impersonate/${userId}`
      );
      dispatch(
        startImpersonation({
          user: res.user,
          token: res.token,
          adminToken: currentToken,
          adminUser: currentUser,
        })
      );
      queryClient.clear();
      navigate("/dashboard");
    } finally {
      setLoading(false);
    }
  };

  return { impersonate, loading, currentUser };
};
